import { uniqBy } from 'lodash';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { type PaymentMethodName } from 'data/__generated__';
import { getPaymentMethodLabel } from 'helpers/paymentMethods';

import { getPaymentMethodTargetPath } from './PaymentIdLink';

// Un libellé par moyen de paiement de la transaction, chacun vers la fiche de son type ; ceux qui n'en ont pas (badge
// pro, intégrations) restent du texte.
// Dédoublonné : une carte refusée puis réessayée figure deux fois dans `paymentMethods`.
export const TransactionPaymentMethodsCell = ({
    paymentMethods,
}: {
    paymentMethods?: { _id: string; paymentMethodName: PaymentMethodName }[] | null;
}) => {
    if (!paymentMethods?.length) {
        return <span>-</span>;
    }

    return (
        <Container>
            {uniqBy(paymentMethods, '_id').map((paymentMethod) => {
                const path = getPaymentMethodTargetPath(paymentMethod);
                const label = getPaymentMethodLabel(paymentMethod.paymentMethodName);
                return path ? (
                    <MethodLink key={paymentMethod._id} to={path}>
                        {label}
                    </MethodLink>
                ) : (
                    <span key={paymentMethod._id}>{label}</span>
                );
            })}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px 8px;
`;

const MethodLink = styled(Link)`
    color: ${({ theme }) => theme.ctaPrimaryHoveredColor};
    text-decoration: none;
    white-space: nowrap;

    &:hover {
        text-decoration: underline;
    }
`;
